import { render, staticRenderFns } from "./ProductsPublic.vue?vue&type=template&id=9f598b06&"
import script from "./ProductsPublic.vue?vue&type=script&lang=js&"
export * from "./ProductsPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports